import type { FC, ReactNode } from 'react';
import React from 'react';
import { JoyKitThemeProvider } from '@withjoy/joykit';
import { useEventDesignThemingProvider } from '@shared/core/website/theming';

type EventDesignJoyKitThemeOverridesProviderProps = Readonly<{
  children: ReactNode;
}>;

/**
 * EventDesignJoyKitThemeOverridesProvider - Wrapper that reads theme from EventDesignThemingProvider context
 * and passes it to JoyKitThemeProvider.
 *
 * This allows JoyKitThemeProvider to get theme computed by EventDesignThemingProvider without
 * requiring components to manually call useEventDesignThemingProvider() and pass theme down.
 *
 * MUST be used within EventDesignThemingProvider context.
 *
 * This is separate from EventDesignThemingProvider because we only want to apply the theme overrides
 * to portions of the UI.
 */
export const EventDesignJoyKitThemeOverridesProvider: FC<EventDesignJoyKitThemeOverridesProviderProps> = ({ children }) => {
  const { theme } = useEventDesignThemingProvider();
  return <JoyKitThemeProvider theme={theme}>{children}</JoyKitThemeProvider>;
};
